module.exports = __webpack_public_path__ + "static/img/70-70.ebe05fa.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/loader/GIF2/70-70.gif
// module id = YBfs
// module chunks = 7